import React, { useState, useEffect, useRef } from "react"
import { useForm, Controller } from "react-hook-form"
import * as emailjs from "emailjs-com"
import { motion } from "framer-motion"
import styled, { css } from "styled-components"
import Cleave from "cleave.js/react"
import "cleave.js/dist/addons/cleave-phone.us"
import { useWindowSize } from "@abmg-components"

import ContactBanner from "./contact-banner"
import RadioChecked from "@images/mb-contact/selected-radio2.svg"
import RadioUnchecked from "@images/mb-contact/unselected-radio2.svg"

const size = {
  desktop: 1000,
  tablet: 800,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const HeaderContainer = styled.div`
  padding: 0 48px;
  margin: 0 auto;
  ${below.mobile`
    padding: 64px 24px 0;
  `}
`
const FormContainer = styled.div`
  background-color: white;
  max-width: 760px;
  margin: 0 auto;
  border-radius: 4px;
`
const FormWrapper = styled.div`
  h1 {
    margin: 96px 0 16px;
    ${below.mobile`

    margin:0;
    `}
    &.success {
      text-align: center;
      margin-top: 312px;
      ${below.mobile`margin-top: 40px;`}
    }
  }
  .subhead {
    font-size: 20px;
    line-height: 28px;
    color: var(--alt-black);
    margin-bottom: 64px;
    ${below.mobile`
    margin-bottom: 28px;
    `}
  }

  a {
    color: var(--pacific-blue);
  }
  .subhead-success {
    font-size: 24px;
    line-height: 32px;
    color: #000000;
    margin-bottom: 48px;
    text-align: center;
  }

  ${below.desktop``};

  div.form-group {
    position: relative;
    &.input {
      max-height: 120px;
      input {
        font-family: "Playfair Display", serif;
        font-size: 44px;
        line-height: 60px;
        color: #75808f;
        display: block;
        width: 100%;
        border: none;
        outline: none;
        border-radius: 0px;
        border-bottom: 2px solid var(--alt-black);
        margin-bottom: 56px;
        transition: 0.5s ease-in-out;
        :focus {
          ::placeholder {
            opacity: 0;
          }
        }
        ::placeholder {
          color: #acb3bc;
          opacity: 1;
          transition: 0.3s ease-in-out;
        }
        &:focus + label {
          opacity: 1;
        }

        &.dirty {
          color: var(--alt-black);
        }

        ${below.mobile`
    font-size: 22px;
    line-height: 28px;
    margin-bottom: 48px;
    `};
        :focus {
          color: var(--alt-black);
          border-color: var(--pacific-blue);
        }
        &.errors {
          border-color: #eb5757 !important;
        }
      }
    }
  }

  label {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 4px;
    text-transform: capitalize;
    color: var(--alt-black);
    position: absolute;
    left: 0;
    top: -20px;
    transition: 0.4s ease-in-out;
    opacity: 0;
    pointer-events: none;
    &.text-area {
      top: -26px;
    }
  }

  textarea {
    font-family: "Playfair Display", serif;
    font-size: 44px;
    line-height: 60px;
    padding-bottom: 12px;
    color: #acb3bc;
    border: none;
    border-bottom: 2px solid #75808f;
    border-radius: 0px;
    outline: none;
    width: 100%;
    margin: 2px 0 56px;
    resize: none;
    overflow: hidden;
    :focus {
      color: black;
      border-color: var(--pacific-blue);
      ::placeholder {
        opacity: 0;
      }
    }
    ::placeholder {
      color: #acb3bc;
      opacity: 1;
      transition: 0.3s ease-in-out;
    }
    &:focus + label {
      opacity: 1;
    }
    &.dirty {
      color: var(--alt-black);
    }
    &.errors {
      border-color: hsla(360, 84%, 65%, 1) !important;
    }
    ${below.mobile`
    font-size: 22px;
    line-height: 28px;
    border-bottom: 1px solid;
    padding-bottom: 4px;
    `}
  }
`
const Ghost = styled.div`
  font-family: "Playfair Display", serif;
  font-size: 44px;
  line-height: 60px;
  padding-bottom: 12px;
  z-index: -10;
  visibility: hidden;
  /* position: absolute; */
  max-height: 320px;
  ${below.mobile`
    font-size: 22px;
    line-height: 28px;
    padding-bottom: 4px;
    `}
`
const PrimaryButton = styled.button`
  display: block;
  background-color: transparent;
  border: 1px solid #acb3bc;
  font-size: 16px;
  line-height: 20px;
  padding: 12px 40px;
  margin: 0 0 80px;
  border-radius: 4px;
  cursor: pointer;
  color: #acb3bc;
  transition: 0.3s ease-in-out;
  pointer-events: none;
  &.dirty {
    background-color: var(--pacific-blue);
    color: white;
    border: 1px solid var(--pacific-blue);
    pointer-events: auto;
  }
  ${below.tablet`
  margin: 0 0 56;
  `}
  ${below.mobile`
  font-size: 18px;
  line-height: 24px;
  width: 100%;
  padding: 12px 24px;
  margin: 0 0 48;
  `}
`
const SecondaryButton = styled.button`
  font-size: 24px;
  line-height: 32px;
  padding: 16px 0px 16px;
  display: block;
  margin: 0 auto 312px;
  cursor: pointer;
  width: 328px;
  transition: 0.3s ease-in-out;
  border: 1px solid var(--pacific-blue);
  color: var(--pacific-blue);
  background-color: hsla(211, 81%, 40%, 0.1);
  ${below.mobile`margin-bottom: 48px;`}
`

const Rosie = styled.input`
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  z-index: -1;
`
const ErrorMessage = styled.div`
  position: absolute;
  transform: translateY(-52px);
  font-size: 12px;
  line-height: 16px;
  color: #eb5757;
  ${below.mobile`font-size: 10px; transform: translateY(-40px)`}
  &.text-area {
    ${below.mobile`transform: translateY(-56px)`}
  }
`
const RadioLabel = styled.label`
  color: var(--alt-black);
  text-transform: initial !important;

  display: inline-block;
  border-radius: 4px;
  margin-top: 16px;
  position: relative !important;
  opacity: 1 !important;
  pointer-events: initial !important;
  margin-right: 24px;
  padding-left: 24px;
  &:last-child {
    margin-right: 0px;
  }
  &:hover {
  }
  :before {
    content: "";
    background-image: url(${RadioUnchecked});
    position: absolute;
    width: 16px;
    height: 16px;
    left: 0px;
    top: 2px;
  }
`
const RadioInput = styled.input`
  position: fixed;
  pointer-events: initial;
  opacity: 0;
  width: 0;
  &:checked + label {
    ::before {
      background-image: url(${RadioChecked});
    }
  }
`
const RadioGroup = styled.div`
  margin-bottom: 48px;
  ${below.mobile`margin-bottom: 24px;`}
`
const RadioGroupLabel = styled.div`
  display: block;
  margin-bottom: 32px;
  font-size: 16px;
  line-height: 20px;
  color: var(--alt-black);
  transition: 0.4s ease-in-out;
`

const Form = props => {
  const {
    register,
    handleSubmit,
    formState: { errors, dirtyFields },
    watch,
    control,
  } = useForm({ mode: "onTouched" })
  const watchMessage = JSON.stringify(watch("message"))
  const [isSubmitted, setSubmitted] = useState(false)
  const [textareaHeight, setTextAreaHeight] = useState(64)
  const ghost = useRef(null)

  const onSubmit = data => {
    const cleanMessage = data.message.replace(/www.|http:\/\/|https:\/\//gi, "")
    const bogusMessage = () => {
      return (
        data.message.match(/to my images you/g) ||
        data.message.match(/SEO/g) ||
        data.message.match(/YourNewSecretWeapon/g) ||
        data.message.match(/ContactRobotPro/g) ||
        data.message.match(/copyright/g) ||
        data.message.match(/storage.googleapis.com/g)
      )
    }

    // CREATE FORM DATA
    const templateParams = {
      mb_email:
        data.name === "test" || data.email === "test@test.com" || bogusMessage()
          ? "webteam@atlanticbay.com"
          : props.mbEmail.join(";"),
      mb_name: props.mbFullName,
      contact_name: data.name,
      contact_email: data.email,
      contact_phone: !data.phone ? "none provided" : data.phone,
      contact_preference: !data.contact_preference
        ? "none provided"
        : data.contact_preference,
      message: cleanMessage,
    }

    // SUBMIT FORM
    if (!data.pass) {
      emailjs
        .send(
          "default_service",
          "mb_contact",
          templateParams,
          "user_rZnp1QjHFiOah6cAnsph7",
        )
        .then(
          function (response) {},
          function (err) {},
        )
    } else {
    }

    // RESET FORM AND SET FLAG FOR SUCCESS SCREEN
    setSubmitted(true)
    window && window.scrollTo(0, 0)
  }

  const windowWidth = useWindowSize().width
  useEffect(() => {
    !isSubmitted && setTextAreaHeight(ghost.current.clientHeight)
  }, [watchMessage, isSubmitted])

  useEffect(() => {
    setTextAreaHeight(ghost.current?.clientHeight)
  }, [windowWidth])

  return (
    <>
      {!isSubmitted ? (
        <>
          <HeaderContainer>
            <FormContainer>
              <FormWrapper>
                <h1>Get in touch</h1>
                <div className="subhead">
                  Use the form below or keep scrolling for{" "}
                  <a href="#additional-contact">additional contact methods</a>.
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Rosie
                    title="pass"
                    name="pass"
                    autoComplete="off"
                    tabIndex="-1"
                    {...register("pass")}
                  />

                  <div className="input form-group">
                    <input
                      name="name"
                      aria-label="Enter name"
                      {...register("name", { required: true, minLength: 2 })}
                      placeholder="Your name"
                      className={`${errors.name && "errors"} ${
                        dirtyFields.name && "dirty"
                      }`}
                    />
                    {errors.name && (
                      <ErrorMessage>
                        Almost there! Please enter a name that is 2 characters
                        or longer.
                      </ErrorMessage>
                    )}
                    <label className="name" htmlFor="name">
                      name
                    </label>
                  </div>

                  <div className="input form-group">
                    <input
                      name="email"
                      aria-label="Enter email address"
                      {...register("email", {
                        required: true,
                        pattern:
                          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      })}
                      placeholder="Your email"
                      className={`${errors.email && "errors"} ${
                        dirtyFields.email && "dirty"
                      }`}
                    />
                    {errors.email && (
                      <ErrorMessage>
                        Oh, no! That doesn’t seem to be a email we recognize.
                        Could you try again?
                      </ErrorMessage>
                    )}
                    <label htmlFor="email">email</label>
                  </div>

                  <div className="input form-group">
                    <Controller
                      render={({ field }) => (
                        <Cleave
                          options={{
                            phone: true,
                            phoneRegionCode: "us",
                            delimiter: "-",
                          }}
                          placeholder="Phone number"
                          {...field}
                        />
                      )}
                      control={control}
                      name="phone"
                      rules={{ required: true, minLength: 12 }}
                      aria-label="Enter phone"
                      defaultValue=""
                      className={`${errors.phone && "errors"} ${
                        dirtyFields.phone && "dirty"
                      }`}
                    />
                    {errors.phone && (
                      <ErrorMessage>
                        Please enter a valid phone number with the area code.
                      </ErrorMessage>
                    )}
                    <label htmlFor="phone">phone</label>
                  </div>

                  <RadioGroup>
                    <RadioGroupLabel>
                      How would you like us to contact you? (optional)
                    </RadioGroupLabel>

                    <RadioInput
                      name="contact_preference"
                      aria-label="contact-preference-phone"
                      type="radio"
                      value="phone"
                      id="phone"
                      {...register("contact_preference")}
                    />
                    <RadioLabel htmlFor="phone">Phone call</RadioLabel>

                    <RadioInput
                      name="contact_preference"
                      aria-label="contact-preference-text"
                      type="radio"
                      value="text"
                      id="text"
                      {...register("contact_preference")}
                    />
                    <RadioLabel htmlFor="text">Text</RadioLabel>

                    <RadioInput
                      name="contact_preference"
                      aria-label="contact-preference-email"
                      type="radio"
                      value="email"
                      id="email"
                      {...register("contact_preference")}
                    />
                    <RadioLabel htmlFor="email">Email</RadioLabel>
                  </RadioGroup>

                  <div style={{ position: "relative" }}>
                    <motion.textarea
                      initial={{ height: 64 }}
                      animate={{ height: textareaHeight }}
                      style={{
                        overflow: textareaHeight >= 320 ? "auto" : "hidden",
                      }}
                      name="message"
                      aria-label="Enter message"
                      {...register("message", { required: true, minLength: 7 })}
                      placeholder="Type your message here"
                      className={`${errors.message && "errors"} ${
                        dirtyFields.message && "dirty"
                      }`}
                    />
                    {errors.message && (
                      <ErrorMessage className="text-area">
                        We'll need just a little bit more information than that.
                      </ErrorMessage>
                    )}
                    <label htmlFor="message" className="text-area">
                      message
                    </label>
                  </div>

                  <div style={{ position: "relative", maxHeight: 1 }}>
                    <Ghost ref={ghost}>{watchMessage}</Ghost>
                  </div>

                  <PrimaryButton
                    type="submit"
                    className={`${
                      dirtyFields.message &&
                      dirtyFields.name &&
                      dirtyFields.email &&
                      "dirty"
                    }`}
                  >
                    Send message
                  </PrimaryButton>
                </form>
              </FormWrapper>
            </FormContainer>
          </HeaderContainer>
          <ContactBanner title={props.bannerTitle} image={props.bannerImage} />
        </>
      ) : (
        <>
          <HeaderContainer>
            <FormContainer>
              <FormWrapper>
                <h1 className="success">Thanks for reaching out!</h1>
                <div className="subhead-success">
                  Thank you for taking the time to reach out! Expect to hear
                  from us shortly.
                </div>
                <SecondaryButton onClick={() => setSubmitted(false)}>
                  Send another message
                </SecondaryButton>
              </FormWrapper>
            </FormContainer>
          </HeaderContainer>
          <ContactBanner title={props.bannerTitle} image={props.bannerImage} />
        </>
      )}
    </>
  )
}

export default Form
